export default "__VITE_ASSET__0a12fe53__"